// System Settings module page-level translations

export default {
  // ─── Changelog ─────────────────────────────────────────────────────────────
  'system.changelog.type.feature': 'Feature',
  'system.changelog.type.improve': 'Improvement',
  'system.changelog.type.fix': 'Fix',
  'system.changelog.type.breaking': 'Breaking',
  'system.changelog.tag.latest': 'Latest',
  'system.changelog.tag.current': 'Current',

  // ─── Global Config ─────────────────────────────────────────────────────────
  'system.config.save': 'Save',

  // Password Policy
  'system.config.pwd.tab': 'Password Policy',
  'system.config.pwd.title': 'Password Policy',
  'system.config.pwd.desc': 'Configure the user password change cycle',
  'system.config.pwd.expireDays.label': 'Password Expiry (Days)',
  'system.config.pwd.expireDays.tooltip': 'Users must change their password within this period. Set to 0 for no limit.',
  'system.config.pwd.expireDays.required': 'Please enter the number of days',
  'system.config.pwd.maxError.label': 'Max Password Error Count',
  'system.config.pwd.maxError.tooltip': 'The account will be disabled after exceeding this number of consecutive wrong password attempts within the time window. Set to 0 for no limit.',
  'system.config.pwd.maxError.required': 'Please enter the maximum error count',
  'system.config.pwd.errorWindow.label': 'Error Count Time Window (Hours)',
  'system.config.pwd.errorWindow.tooltip': 'The account will be disabled when the cumulative error count reaches the limit within this time window. Set to 0 for no limit.',
  'system.config.pwd.errorWindow.required': 'Please enter the time window in hours',
  'system.config.pwd.save.success': 'Password policy saved successfully',

  // Email Configuration
  'system.config.email.tab': 'Email Configuration',
  'system.config.email.title': 'Email Configuration',
  'system.config.email.desc': 'Configure the email send method: SMTP or Postmark API',
  'system.config.email.sendType.label': 'Send Method',
  'system.config.email.sendType.smtp': 'SMTP',
  'system.config.email.sendType.postmark': 'Postmark API',
  'system.config.email.sendType.required': 'Please select a send method',
  'system.config.email.host.label': 'SMTP Server',
  'system.config.email.host.required': 'Please enter the SMTP server address',
  'system.config.email.port.label': 'Port',
  'system.config.email.port.required': 'Please enter the port',
  'system.config.email.encrypt.label': 'Encryption',
  'system.config.email.encrypt.required': 'Please select an encryption method',
  'system.config.email.encrypt.placeholder': 'Please select',
  'system.config.email.username.label': 'Account',
  'system.config.email.username.required': 'Please enter the account',
  'system.config.email.username.placeholder': 'Email account',
  'system.config.email.fromEmail.label': 'Sender Email',
  'system.config.email.fromEmail.required': 'Please enter the sender email',
  'system.config.email.fromEmail.invalid': 'Please enter a valid email address',
  'system.config.email.fromName.label': 'Sender Name',
  'system.config.email.fromName.required': 'Please enter the sender name',
  'system.config.email.fromName.placeholder': 'e.g. System Notification',
  'system.config.email.authCode.label': 'Auth Code',
  'system.config.email.authCode.required': 'Please enter the email auth code',
  'system.config.email.authCode.placeholder': 'Email auth code or app-specific password',
  'system.config.email.save.success': 'Email configuration saved successfully',

  // Email Templates
  'system.config.template.tab': 'Email Templates',
  'system.config.template.add.title': 'New User Email Template',
  'system.config.template.add.desc': "Configure the email content sent when a new user is created. Supports variables '{userAccount}' and '{password}'.",
  'system.config.template.reset.title': 'Reset Password Email Template',
  'system.config.template.reset.desc': "Configure the email content sent when a user resets their password. Supports variables '{userAccount}' and '{resetLink}'.",
  'system.config.template.subject.label': 'Email Subject',
  'system.config.template.subject.required': 'Please enter the email subject',
  'system.config.template.content.label': 'Email Template Content',
  'system.config.template.content.required': 'Please enter the email template content',
  'system.config.template.content.extra': 'Line breaks are supported. Press Enter to create a new paragraph. The paragraph format will be preserved when sending.',
  'system.config.template.add.save.success': 'Email template saved successfully',
  'system.config.template.reset.save.success': 'Reset password email template saved successfully',
  'system.config.template.forget.title': 'Forgot Password Email Template',
  'system.config.template.forget.title.placeholder':'For example: forgot password email ',
  'system.config.template.forget.desc':"Configure the email content to be sent when a user forgets their password, supporting the variable '{authCode}'.",
  'system.config.template.forget.desc.placeholder':"Please click the button to reset password http://example.com?authCode='{authCode}', effective within 15 minutes",
  'system.config.template.forget.content.extra': "Line breaks are supported. Press Enter to create a new paragraph. The paragraph format will be preserved when sending. You can use variable '{authCode}'.",
  'system.config.template.forget.save.success': 'Forgot password email template saved successfully',

  // Storage Configuration
  'system.config.storage.tab': 'Upload File Configuration',
  'system.config.storage.title': 'Upload Capacity Settings',
  'system.config.storage.desc': 'Set the file upload capacity limit per user, per company, and for the entire tenant. 0 means no limit.',
  'system.config.storage.user.label': 'Per-User Capacity Limit (MB)',
  'system.config.storage.user.tooltip': 'Total files a single user can upload. Set to 0 for no limit.',
  'system.config.storage.user.required': 'Please enter the per-user capacity limit',
  'system.config.storage.company.label': 'Per-Company Capacity Limit (MB)',
  'system.config.storage.company.tooltip': 'Total files all users in a company can upload. Set to 0 for no limit.',
  'system.config.storage.company.required': 'Please enter the per-company capacity limit',
  'system.config.storage.tenant.label': 'Total Tenant Capacity Limit (MB)',
  'system.config.storage.tenant.tooltip': 'Total file upload limit for all companies under this tenant. Set to 0 for no limit.',
  'system.config.storage.tenant.required': 'Please enter the tenant capacity limit',
  'system.config.storage.save.success': 'Upload capacity configuration saved successfully',

  // ─── App Info ───────────────────────────────────────────────────────────────
  'system.info.version.title': 'Version Information',
  'system.info.version.current': 'Current Version',
  'system.info.version.latest': 'Latest Version',
  'system.info.version.build': 'Build Version',
  'system.info.version.serviceStatus': 'Service Status',
  'system.info.version.status.ok': 'Running Normally',
  'system.info.version.status.error': 'Running Abnormally',
  'system.info.update.title': 'System Update',
  'system.info.update.hasNew': 'New Version Available',
  'system.info.update.desc': 'Configuration required before use',
  'system.info.update.btn': 'Configure Software Update',
  'system.info.client.title': 'Client Address',
  'system.info.client.desc': 'Client supports Admin Portal and Client Portal',
  'system.info.client.btn': 'Go to Client',
  'system.info.docs.title': 'Help Documentation',
  'system.info.docs.desc': 'View the full product documentation to learn how to use all features',
  'system.info.docs.btn': 'View Docs',
  'system.info.docker.title': 'Docker Image',
  'system.info.docker.desc': 'The backend system is released via Docker images. View the latest version.',
  'system.info.docker.btn': 'Docker Hub',

  // ─── License Management ─────────────────────────────────────────────────────
  'system.license.status.valid': 'Valid',
  'system.license.status.invalid': 'Invalid',
  'system.license.status.expired': 'Expired',
  'system.license.authorized': 'System Authorized',
  'system.license.unauthorized': 'System Not Authorized',
  'system.license.authorizedDesc': 'The system currently has a valid License authorization.',
  'system.license.unauthorizedDesc': 'The system does not have a valid authorization. Please contact the administrator to obtain a License.',
  'system.license.statusLabel': 'Authorization Status',
  'system.license.running': 'Running Normally',
  'system.license.notAuthorized': 'Not Authorized',
  'system.license.info.title': 'Current License Information',
  'system.license.info.desc': 'Displays the current License authorization status',
  'system.license.field.activateTime': 'Activation Time',
  'system.license.field.expireTime': 'Expiry Time',
  'system.license.field.status': 'Status',
  'system.license.field.company': 'Company Name',
  'system.license.field.userLimit': 'User Limit',
  'system.license.field.features': 'Licensed Features',
  'system.license.expireSoon': 'Expiring Soon',
  'system.license.refresh': 'Click to refresh authorization info',

  // ─── Menu Configuration ─────────────────────────────────────────────────────
  'system.menu.title': 'Menu Configuration',
  'system.menu.empty': 'No menus',
  'system.menu.save': 'Save Changes',
  'system.menu.sort.success': 'Order saved',
  'system.menu.sort.fail': 'Failed to save order',
  'system.menu.detail.empty': 'Select a menu on the left to view details',
  'system.menu.form.basicInfo': 'Basic Information',
  'system.menu.form.configSettings': 'Configuration Settings',
  'system.menu.form.name.label': 'Menu Name',
  'system.menu.form.name.placeholder': 'Please enter the menu name',
  'system.menu.form.name.required': 'Please enter the menu name',
  'system.menu.form.name.tooltip': 'The name displayed in the sidebar',
  'system.menu.form.path.label': 'Route Path',
  'system.menu.form.path.placeholder': 'Please enter the route path',
  'system.menu.form.path.tooltip': 'The corresponding frontend route path, must be unique',
  'system.menu.form.icon.label': 'Menu Icon',
  'system.menu.form.icon.tooltip': 'The icon displayed to the left of the menu',
  'system.menu.form.sort.label': 'Sort Order',
  'system.menu.form.sort.tooltip': 'The display order of the menu',
  'system.menu.form.remark.label': 'Remark',
  'system.menu.form.remark.placeholder': 'Please enter a remark',
  'system.menu.tree.button': 'Button',
  'system.menu.tree.disabled': 'Disabled',

  // ─── Changelog Entries ──────────────────────────────────────────────────────
  // v0.0.8
  'system.changelog.v008.item0': 'Added Token consumption statistics and quota management (entry: User Management > Quota, Company Management > Quota)',
  'system.changelog.v008.item1': 'Added Excel bulk import for User Management, supporting batch user creation',
  'system.changelog.v008.item2': 'Added workbench / app comprehensive query panel',
  'system.changelog.v008.item3': 'Added system settings module: global config / license management / changelog / app info',
  'system.changelog.v008.item4': 'Added fuzzy search to global search box (except operation logs due to large data volume)',
  'system.changelog.v008.item5': 'Added quick status filter to some lists',
  'system.changelog.v008.item6': 'Added user registration email notification and email template configuration',
  'system.changelog.v008.item7': 'Added field sorting to global lists',
  'system.changelog.v008.item8': 'Optimized list field customization, local saving, and export report field synchronization',
  'system.changelog.v008.item9': 'Optimized sidebar menu collapse and expand behavior',
  'system.changelog.v008.item10': 'Optimized interaction experience on some pages',
  // v0.0.7
  'system.changelog.v007.item0': 'Added app token consumption ranking with support for app, company, and user dimensions',
  'system.changelog.v007.item1': 'Added sorting toggle for all menus and fuzzy search for all search fields',
  'system.changelog.v007.item2': 'Optimized menu i18n cache handling logic to improve language switching speed',
  'system.changelog.v007.item3': 'Refactored app analytics module, removed deprecated mock data components',
  'system.changelog.v007.item4': 'Fixed app cache data mixing issue in multi-user scenarios',
};
